import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62fab03c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=62fab03c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fab03c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62fab03c')) {
      api.createRecord('62fab03c', component.options)
    } else {
      api.reload('62fab03c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62fab03c&scoped=true", function () {
      api.rerender('62fab03c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ViewData/index.vue"
export default component.exports